export default __webpack_public_path__ + "static/media/nft.d148d8d0.svg";